var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',{attrs:{"title":"stock-movement.outcome.new.label","bread-crumb-data":_vm.breadCrumbData}},[(_vm.movement)?_c('outcome-stock-movement-form',{attrs:{"movement":_vm.movement}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }